import React from 'react';
import { MailOutline, PhoneOutlined } from '@mui/icons-material';
import { Colors } from 'library';
import { useClient } from 'shared';
import { RText, RLink, RStack } from 'recruit/components';

interface CenterContact {
    first_name: string;
    phone_number: string;
    email: string;
}

export function ContactInfo() {
    const { data: contact, loading, error } = useClient<CenterContact>({ url: 'api/dashboard/center-contact/' });
    const contactInfo =
        loading || error || !contact ? { email: 'team@join-tandem.com', phone_number: '(614) 907-4374' } : contact;

    return (
        <RStack gap="sm" padding="sm">
            <RText weight="bold">Need help?</RText>
            <RLink
                href={`mailto:${contactInfo.email}`}
                underline={false}
                weight="medium"
                icon={<MailOutline sx={iconSx} />}
                wrap
            >
                {contactInfo.email}
            </RLink>
            <RLink
                href={`tel:${contactInfo.phone_number}`}
                underline={false}
                weight="medium"
                icon={<PhoneOutlined sx={iconSx} />}
                wrap
            >
                {contactInfo.phone_number}
            </RLink>
        </RStack>
    );
}

const iconSx = { fontSize: 16, color: Colors.darkNavy };
